import { StationeryProduct } from '@shared/utils/print-price/types';

export const getProductAttribute = ({ product, attributeId }: { product: StationeryProduct; attributeId: string }) => {
  const attribute = product.attributes.find(attr => attr.attributeId === attributeId);
  return attribute;
};
